import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { I18n } from 'react-redux-i18n';
import ClearIcon from '@material-ui/icons/Clear';
import * as timeslotActions from '../../../../service/timeslot/actions';
import { confirm } from '../../../../utils';
import { getConfiguredByProduct, getFlatProducts } from './selector';

// Colonne droite : récapitulatif des produits configurés + leur état.
// La croix efface toute la config du produit (via popup de confirmation).
class ConfiguredRecap extends React.Component {
	buildRows() {
		const { configuredByProduct, flatProducts } = this.props;
		return Object.keys(configuredByProduct)
			.map(idProduct => {
				const product = flatProducts[idProduct];
				const counts = configuredByProduct[idProduct];
				return {
					id: idProduct,
					name: product ? product.name : `#${idProduct}`,
					enable: counts.enable,
					disable: counts.disable,
				};
			})
			.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
	}

	onRemove = row => {
		confirm(
			I18n.t('settings.binding.remove_confirm', { name: row.name })
		).then(
			() =>
				this.props.actions.saveTimeslotRules({
					type: 'product',
					id: row.id,
					rules: [],
				}),
			() => {}
		);
	};

	onEdit = row => {
		this.props.onOpenProduct(row.id);
	};

	render() {
		const rows = this.buildRows();

		return (
			<React.Fragment>
				<h2>{I18n.t('settings.binding.recap_title')}</h2>
				<div className="binding-recap-list">
					{rows.length ? (
						rows.map(row => (
							<div key={row.id} className="binding-recap-item">
								<div
									className="binding-recap-main"
									onClick={() => this.onEdit(row)}>
									<span className="binding-recap-name">{row.name}</span>
									<span className="binding-recap-state">
										{I18n.t('settings.binding.recap_state', {
											enable: row.enable,
											disable: row.disable,
										})}
									</span>
								</div>
								<span
									className="binding-recap-remove"
									onClick={() => this.onRemove(row)}>
									<ClearIcon fontSize="small" />
								</span>
							</div>
						))
					) : (
						<p className="binding-empty">
							{I18n.t('settings.binding.recap_empty')}
						</p>
					)}
				</div>
			</React.Fragment>
		);
	}
}

ConfiguredRecap.propTypes = {
	onOpenProduct: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
	configuredByProduct: getConfiguredByProduct(state),
	flatProducts: getFlatProducts(state),
});

const mapDispatchToProps = dispatch => ({
	actions: bindActionCreators(timeslotActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfiguredRecap);
